import { useQuery } from '@tanstack/react-query'

import { CombinationItemViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

interface Props {
    cat_id: string
}

export function useGetCombinationsList({ cat_id }: Props) {
    return useQuery<unknown, unknown, CombinationItemViewModel[]>({
        queryKey: QueryKeys.PLP.CombinationsList(cat_id),
        queryFn: () => {
            return fetchRequest({
                endpoint: `/combinations/category/${cat_id}`,
                method: 'GET',
                serviceName: 'cml',
            })
        },
        enabled: !!cat_id,
    })
}
